
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexT6Lqm2qW3kTmOQLS0429nt6oauEgxUBZGtr9ZaYouh8Meta } from "/working_dir/Frontend/pages/index.vue?macro=true";
import { default as loginTII5Bm4Y3PaOk4MCXGAvJJVFpFN_45aSr5bt_45m4qyjMqQMeta } from "/working_dir/Frontend/pages/login.vue?macro=true";
import { default as obrigado99VdgOCWyhLtkLs4THr60lYh7EsjburczN9XwnvA_8EMeta } from "/working_dir/Frontend/pages/obrigado.vue?macro=true";
import { default as tcle0lyXkGTkR8jfSAl_45YWMTC75uhNgK_fFcO4KtH4or5HQMeta } from "/working_dir/Frontend/pages/responder/tcle.vue?macro=true";
import { default as indexALr1ST2PDaHiqqkpxAC71JkA_ziDX9I4qWguK_uULuQMeta } from "/working_dir/Frontend/pages/responder/index.vue?macro=true";
import { default as _91id_93FZzHY1yEyZ3AGAgvawfu0237AYTdPLLhzpFDM7r6bnMMeta } from "/working_dir/Frontend/pages/download/qfa/[id].vue?macro=true";
import { default as _91id_939s0NfeBC4VyU2d0N09hzPV1Cg5PzWKejTWRdPHP85JAMeta } from "/working_dir/Frontend/pages/download/r24h/[id].vue?macro=true";
import { default as _91id_93ZBDGlSxMSCrJSo6eTJ1Zci7uaHfM1hrxZgLVUAWPMg8Meta } from "/working_dir/Frontend/pages/download/screener/[id].vue?macro=true";
import { default as responderQFAqqmt0VKxZY7r6gnRCIvbkfDjlxKYnI5gPZveiGW87z0Meta } from "/working_dir/Frontend/pages/responder/responderQFA.vue?macro=true";
import { default as termosDeUsozSU4OXdpH7P8Ahk1buh_3WLFxSl_45Q9v4ZDVLKvjt6KQMeta } from "/working_dir/Frontend/pages/pesquisador/termosDeUso.vue?macro=true";
import { default as responderR24Hi3rsRL_45qUU7ISKw67yKxvmC_5aVPPM_45M_9mVBqq6nJgMeta } from "/working_dir/Frontend/pages/responder/responderR24H.vue?macro=true";
import { default as _91id_93zwP2P6A2jP8NACpn8B3oD39eXkL7rSqI4jD3HDecy8IMeta } from "/working_dir/Frontend/pages/download/escala_guia/[id].vue?macro=true";
import { default as alterarMeuCadastroX2tlGmwkerw4uZHw7KZs7Ja9PVg_45XvTg8AkUnyz_45ODwMeta } from "/working_dir/Frontend/pages/usuario/alterarMeuCadastro.vue?macro=true";
import { default as responderScreenerehFN2UsQirxhMwRxang0EV8Jve_ZVjmLnurMv03W0h8Meta } from "/working_dir/Frontend/pages/responder/responderScreener.vue?macro=true";
import { default as _91id_93ThuMpWoGDJzUywkCppV1iRtfbPACpL1R2qyAWH_45xo0MMeta } from "/working_dir/Frontend/pages/download/nova_rotulagem/[id].vue?macro=true";
import { default as responderEscalaGuiavW0imHVso_F9cctLQ8R4GEAqYGtpFX9QkdC1XVwRIFcMeta } from "/working_dir/Frontend/pages/responder/responderEscalaGuia.vue?macro=true";
import { default as avisosEAlertasSistemaClbQiU_NunQqq2fPQbuhAGsAgVe_UQLz43r6AiLapH0Meta } from "/working_dir/Frontend/pages/usuario/avisosEAlertasSistema.vue?macro=true";
import { default as dadosEstatisticosYSANeD3fTTbjgqZ0gwqX37B0O1rXjkxlIFL4HJ0r89cMeta } from "/working_dir/Frontend/pages/administrador/dadosEstatisticos.vue?macro=true";
import { default as _91id_93RJmxbrFBpQGXjUDfy_MtQqZhpBlt3d9RGFbEBhn85bMMeta } from "/working_dir/Frontend/pages/download/nova_conhecimento/[id].vue?macro=true";
import { default as associarGoogleDriveYnKgxQwd1vsnx5PPCJO_2ET_4553FFn2ttk_45oOMcnIcUgMeta } from "/working_dir/Frontend/pages/pesquisador/associarGoogleDrive.vue?macro=true";
import { default as politicaPrivacidadeJYcWsuNihJIUc9Sz4_45T4ryscM8nEjAQHNV3EDxY5D6wMeta } from "/working_dir/Frontend/pages/pesquisador/politicaPrivacidade.vue?macro=true";
import { default as pesquisasCadastradasgFzr6XjYGftDMjpy_45q6loXmno7ZaHD_yxdbK5qbuMsgMeta } from "/working_dir/Frontend/pages/pesquisador/pesquisasCadastradas.vue?macro=true";
import { default as cadastrarseNaPlataformag_455QR3sDFq4bHnZpnm6MAVqrf9CDD_frbLR6XxqB38EMeta } from "/working_dir/Frontend/pages/pesquisador/cadastrarseNaPlataforma.vue?macro=true";
import { default as responderNovaConhecimentoshSY5mCGJ7NLtbRHuo6__45kTVk9MNoVsC_RotycrocGIMeta } from "/working_dir/Frontend/pages/responder/responderNovaConhecimento.vue?macro=true";
import { default as visualizarErrosSistemanQm9RqbD_45LCJfoWSGXT5d_ivlTSfq2CeECoH54SlslQMeta } from "/working_dir/Frontend/pages/administrador/visualizarErrosSistema.vue?macro=true";
import { default as responderRotulagemNutrinetg1j6SfZiQxdKYR6Ggw9VmLpCM63upgffmMRgDgp5yaUMeta } from "/working_dir/Frontend/pages/responder/responderRotulagemNutrinet.vue?macro=true";
import { default as pesquisadoresCadastradosAtmFgCrUnNVc24XVhDPBAju_aMQtIXhr0i8gXM1262gMeta } from "/working_dir/Frontend/pages/administrador/pesquisadoresCadastrados.vue?macro=true";
import { default as processarBancosResultadosUnqeja_45hYBqP3azrbAR6yowG1P_451e2H0dbO_bf4Ik1kMeta } from "/working_dir/Frontend/pages/administrador/processarBancosResultados.vue?macro=true";
import { default as administradoresCadastradoszELdG6gFV6NZmComAevuePMrOmarHDHbU9x2li_e2H8Meta } from "/working_dir/Frontend/pages/administrador/administradoresCadastrados.vue?macro=true";
import { default as dadosEstatisticosPesquisast_eKXbJJg3YIPOi4a7FuKd6k8vGQpoqWauxPU9zlEVcMeta } from "/working_dir/Frontend/pages/administrador/dadosEstatisticosPesquisas.vue?macro=true";
import { default as visualizarStatusSincronizacaoPesquisadorBzDkpPVMMYiaycSL9V_9ykW9z5NOeA3E4iaRVt_z1uMMeta } from "/working_dir/Frontend/pages/administrador/visualizarStatusSincronizacaoPesquisador.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/working_dir/Frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/working_dir/Frontend/pages/login.vue")
  },
  {
    name: "obrigado",
    path: "/obrigado",
    component: () => import("/working_dir/Frontend/pages/obrigado.vue")
  },
  {
    name: "responder-tcle",
    path: "/responder/tcle",
    component: () => import("/working_dir/Frontend/pages/responder/tcle.vue")
  },
  {
    name: "responder",
    path: "/responder",
    component: () => import("/working_dir/Frontend/pages/responder/index.vue")
  },
  {
    name: "download-qfa-id",
    path: "/download/qfa/:id()",
    component: () => import("/working_dir/Frontend/pages/download/qfa/[id].vue")
  },
  {
    name: "download-r24h-id",
    path: "/download/r24h/:id()",
    component: () => import("/working_dir/Frontend/pages/download/r24h/[id].vue")
  },
  {
    name: "download-screener-id",
    path: "/download/screener/:id()",
    component: () => import("/working_dir/Frontend/pages/download/screener/[id].vue")
  },
  {
    name: "responder-responderQFA",
    path: "/responder/responderQFA",
    component: () => import("/working_dir/Frontend/pages/responder/responderQFA.vue")
  },
  {
    name: "pesquisador-termosDeUso",
    path: "/pesquisador/termosDeUso",
    component: () => import("/working_dir/Frontend/pages/pesquisador/termosDeUso.vue")
  },
  {
    name: "responder-responderR24H",
    path: "/responder/responderR24H",
    component: () => import("/working_dir/Frontend/pages/responder/responderR24H.vue")
  },
  {
    name: "download-escala_guia-id",
    path: "/download/escala_guia/:id()",
    component: () => import("/working_dir/Frontend/pages/download/escala_guia/[id].vue")
  },
  {
    name: "usuario-alterarMeuCadastro",
    path: "/usuario/alterarMeuCadastro",
    component: () => import("/working_dir/Frontend/pages/usuario/alterarMeuCadastro.vue")
  },
  {
    name: "responder-responderScreener",
    path: "/responder/responderScreener",
    component: () => import("/working_dir/Frontend/pages/responder/responderScreener.vue")
  },
  {
    name: "download-nova_rotulagem-id",
    path: "/download/nova_rotulagem/:id()",
    component: () => import("/working_dir/Frontend/pages/download/nova_rotulagem/[id].vue")
  },
  {
    name: "responder-responderEscalaGuia",
    path: "/responder/responderEscalaGuia",
    component: () => import("/working_dir/Frontend/pages/responder/responderEscalaGuia.vue")
  },
  {
    name: "usuario-avisosEAlertasSistema",
    path: "/usuario/avisosEAlertasSistema",
    component: () => import("/working_dir/Frontend/pages/usuario/avisosEAlertasSistema.vue")
  },
  {
    name: "administrador-dadosEstatisticos",
    path: "/administrador/dadosEstatisticos",
    component: () => import("/working_dir/Frontend/pages/administrador/dadosEstatisticos.vue")
  },
  {
    name: "download-nova_conhecimento-id",
    path: "/download/nova_conhecimento/:id()",
    component: () => import("/working_dir/Frontend/pages/download/nova_conhecimento/[id].vue")
  },
  {
    name: "pesquisador-associarGoogleDrive",
    path: "/pesquisador/associarGoogleDrive",
    component: () => import("/working_dir/Frontend/pages/pesquisador/associarGoogleDrive.vue")
  },
  {
    name: "pesquisador-politicaPrivacidade",
    path: "/pesquisador/politicaPrivacidade",
    component: () => import("/working_dir/Frontend/pages/pesquisador/politicaPrivacidade.vue")
  },
  {
    name: "pesquisador-pesquisasCadastradas",
    path: "/pesquisador/pesquisasCadastradas",
    component: () => import("/working_dir/Frontend/pages/pesquisador/pesquisasCadastradas.vue")
  },
  {
    name: "pesquisador-cadastrarseNaPlataforma",
    path: "/pesquisador/cadastrarseNaPlataforma",
    component: () => import("/working_dir/Frontend/pages/pesquisador/cadastrarseNaPlataforma.vue")
  },
  {
    name: "responder-responderNovaConhecimento",
    path: "/responder/responderNovaConhecimento",
    component: () => import("/working_dir/Frontend/pages/responder/responderNovaConhecimento.vue")
  },
  {
    name: "administrador-visualizarErrosSistema",
    path: "/administrador/visualizarErrosSistema",
    component: () => import("/working_dir/Frontend/pages/administrador/visualizarErrosSistema.vue")
  },
  {
    name: "responder-responderRotulagemNutrinet",
    path: "/responder/responderRotulagemNutrinet",
    component: () => import("/working_dir/Frontend/pages/responder/responderRotulagemNutrinet.vue")
  },
  {
    name: "administrador-pesquisadoresCadastrados",
    path: "/administrador/pesquisadoresCadastrados",
    component: () => import("/working_dir/Frontend/pages/administrador/pesquisadoresCadastrados.vue")
  },
  {
    name: "administrador-processarBancosResultados",
    path: "/administrador/processarBancosResultados",
    component: () => import("/working_dir/Frontend/pages/administrador/processarBancosResultados.vue")
  },
  {
    name: "administrador-administradoresCadastrados",
    path: "/administrador/administradoresCadastrados",
    component: () => import("/working_dir/Frontend/pages/administrador/administradoresCadastrados.vue")
  },
  {
    name: "administrador-dadosEstatisticosPesquisas",
    path: "/administrador/dadosEstatisticosPesquisas",
    component: () => import("/working_dir/Frontend/pages/administrador/dadosEstatisticosPesquisas.vue")
  },
  {
    name: "administrador-visualizarStatusSincronizacaoPesquisador",
    path: "/administrador/visualizarStatusSincronizacaoPesquisador",
    component: () => import("/working_dir/Frontend/pages/administrador/visualizarStatusSincronizacaoPesquisador.vue")
  }
]